module.exports = __webpack_public_path__ + "img/allottee1_7-8-2021.330b900b.jpg";